import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VetRoutingModule } from './vet-routing.module';
import { getCommonProviders } from '../all-myao-contexts/providers';

import contextConfig from '../../../config/config-context/vet-config';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VetRoutingModule
  ],
  declarations: [],
  providers: [
    ...getCommonProviders(contextConfig)
  ]
})
export class VetSharedModule { }
